import React from 'react';
import { connect } from 'react-redux';
import { FormattedDate } from 'react-intl';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { Row, Col } from 'react-bootstrap';

import {
  getPaintColorManufacturer,
  getPower,
  getHorsePower,
  getGearbox,
  getMileage,
  getFirstRegistration,
  getFuelType,
} from 'helpers/items';

class SummaryListCarInfos extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      item,
    } = this.props;

    const powerKw = getPower(item, appIntl);
    const firstRegistration = getFirstRegistration(item, appIntl);

    const firstRegistrationDate = firstRegistration ? (
      <FormattedDate value={new Date(firstRegistration.substring(0, 10))} year="numeric" month="2-digit" />
    ) : (
      '-'
    );

    return (
      <Row className="no-margin">
        <Col xs={6} className="no-padding" title={messages.car_color_manufacturer}>
          <div className="overflow-ellipsis">
            <i className="fal fa-palette" />
            {getPaintColorManufacturer(item, appIntl)}
          </div>
        </Col>
        <Col xs={6} className="no-padding" title={messages.car_power}>
          <i className="chedri-engine" />
          {powerKw} kW ({getHorsePower(powerKw)} {messages.car_power_unit})
        </Col>
        <Col xs={6} className="no-padding" title={messages.mileage}>
          <i className="chedri-tire" />
          {getMileage(item, appIntl) ? getMileage(item, appIntl) : '-'} km
        </Col>
        <Col xs={6} className="no-padding" title={messages.car_fueltype}>
          <i className="chedri-fuel" />
          {getFuelType(item, appIntl)}
        </Col>
        <Col xs={6} className="no-padding" title={messages.car_gear}>
          <i className="chedri-gearshift" />
          {getGearbox(item, appIntl) ? getGearbox(item, appIntl) : '-'}
        </Col>
        <Col xs={6} className="no-padding" title={messages.first_registration}>
          <i className="fal fa-calendar-alt" />
          {firstRegistrationDate}
        </Col>

        {/* <h5 className="text-info">{item.owner_company_name}</h5> */}
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default legacyInjectIntl(connect(mapStateToProps)(SummaryListCarInfos));
